import { render, staticRenderFns } from "./EditBusinessLogo.vue?vue&type=template&id=772703e7&scoped=true&"
import script from "./EditBusinessLogo.vue?vue&type=script&lang=ts&"
export * from "./EditBusinessLogo.vue?vue&type=script&lang=ts&"
import style0 from "./EditBusinessLogo.vue?vue&type=style&index=0&id=772703e7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772703e7",
  null
  
)

export default component.exports